import { Box, Typography, Tooltip, useTheme } from '@mui/material';

import { Icon } from '@verantos-dev/shared-components';

interface ReferenceTextSectionProps {
  referenceText: string | null | undefined;
}

export const ReferenceTextSection = ({ referenceText }: ReferenceTextSectionProps) => {
  const theme = useTheme();
  if (!referenceText) return null;

  return (
    <Tooltip
      title={referenceText}
      arrow
      enterDelay={500}
      slotProps={{
        tooltip: {
          sx: {
            maxWidth: 1000,
            maxHeight: 300,
            overflowY: 'auto',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
          },
        },
      }}
    >
      <Icon
        id="reference-txt-info-icon"
        icon="info"
        sx={{
          cursor: 'pointer',
        }}
      />
    </Tooltip>
  );
};
